import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  AvatarIcon,
  CalendarIcon,
  CheckCircledIcon,
  CrossCircledIcon,
  HomeIcon,
  Pencil1Icon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import toast from "react-hot-toast";
import { NavLink, useParams } from "react-router-dom";
import {
  checkTagValidity,
  getUserProfil,
  HOME,
  months,
  years,
} from "../../Utils/Utils";
import {
  BASE_URL,
  EXPORT_RAPPORT,
  LIST_RACCORDEMENT,
  STATS_COUNTER_SURVEY,
  TYPE_RENDEZ_VOUS,
  UPDATE_BRIN,
} from "../../Utils/constant";
import { UpdateRaccordement } from "../../components/Ajouter-intention/UpdateRaccordement";
import { Connecting } from "../../components/Icons/Connecting";
import { UnLink } from "../../components/Icons/UnLink";
import { Counter } from "../../components/Stats/Counter";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { Tabs } from "../../components/Widget/Tab";
import { add } from "../../services/service";
import { useCommentaireStore } from "../../store/CommentaireStore";
import { useStoreStats } from "../../store/StatsStore";
import { useStoreSurvey } from "../../store/SurveyStore";
import { usePortStore } from "../../store/pboStore/listPort";
import { useStoreApp } from "../../store/storeApp";
const Raccordement = () => {
  const { status } = useParams();
  const [selectItem, setSelectItem] = useState(null);
  const [error, setError] = useState(null);
  const [selectBrin, setSelectBrin] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [select, setSelect] = useState("ANNEE");
  const [active, setActive] = useState({
    index: status === "OK" ? 1 : 0,
    value: "",
    tag: "",
  });
  const [numeroTicket, setNumeroTicket] = useState(null);
  const [filterByResult, setFilterByResult] = useState("OK");

  const more = (page) => {
    store.getData(
      LIST_RACCORDEMENT,
      { page: page - 1, param: "", size: 6 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=${filterByResult}`,
    );
  };

  const moreEnAttente = (page) => {
    raccor.getData(
      `${TYPE_RENDEZ_VOUS}?page=${
        page - 1
      }&param=&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_RACCORDEMENT&statutPriseEnCharge=&resultat=&typeRdv=RACCORDEMENT&inTime=`,
    );
  };

  const store = useStoreApp();
  const statsData = useStoreStats();
  const raccor = useStoreSurvey();
  const commentaire = useCommentaireStore();
  const listBrin = usePortStore();

  const listeTabsData = [
    {
      index: 0,
      value: "En attente de raccordement",
      tag: "LISTE_EN_ATTENTE_RACCORDEMENT",
    },
    {
      index: 1,
      value: "Raccoderment realisé",
      tag: "LISTE_RACCORDEMENT",
    },
  ];

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[status === "OK" ? 1 : 0]);
    }
  }, []);

  useEffect(() => {
    store.getData(
      LIST_RACCORDEMENT,
      { page: 0, param: "", size: 6 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=OK&inTime=`,
    );
    commentaire.getData("page=0&param=&size=10000000");
    raccor.getData(
      `${TYPE_RENDEZ_VOUS}?page=0&param=&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_RACCORDEMENT&statutPriseEnCharge=&resultat=&typeRdv=RACCORDEMENT&inTime=`,
    );
    statsData.getData(
      `${STATS_COUNTER_SURVEY}?periode=ANNEE&typeRdv=RACCORDEMENT&mois=&annee=${new Date().getFullYear()}&dateDebut=&dateFin=`,
    );
  }, []);

  const handleDownload = () => {
    const user = getUserProfil();
    fetch(
      `${BASE_URL + EXPORT_RAPPORT}?model=RACCORDEMENTS&username=${
        user?.username
      }`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      },
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `RAPPORT_RACCORDEMENTS.xlsx`; // spécifiez le nom du fichier et son extension
        document.body.appendChild(a);
        a.click();
      })
      .catch((err) => console.error("Erreur de téléchargement:", err));
  };

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center">
        <h3 class="text-3xl font-bold font-mtn">Raccordement</h3>
        <div className="ml-auto flex gap-x-3">
          <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select>
          {select === "MOIS" ? (
            <select
              onChange={(e) => {
                statsData.getData(
                  `${STATS_COUNTER_SURVEY}?periode=${select}&typeRdv=RACCORDEMENT&mois=${
                    e.target.value
                  }&annee=${new Date().getFullYear()}&dateDebut=&dateFin=`,
                );
              }}
              className="my-2 select"
            >
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select
              onChange={(e) => {
                statsData.getData(
                  `${STATS_COUNTER_SURVEY}?periode=ANNEE&typeRdv=RACCORDEMENT&mois=&annee=${e.target.value}&dateDebut=&dateFin=`,
                );
              }}
              className="my-2 select "
            >
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                  statsData.getData(
                    `${STATS_COUNTER_SURVEY}?periode=JOUR&typeRdv=RACCORDEMENT&mois=&annee=&dateDebut=${update[0]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}&dateFin=${update[1]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}`,
                  );
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )}
        </div>
      </div>

      <div className="mt-4 grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-3">
        <Counter
          icon={
            <div className="text-black ">
              <UnLink />
            </div>
          }
          olor={"bg-[#d8e2fc]"}
          label={"Raccordement en attente"}
          count={statsData?.data?.stats?.totalEnAttente}
          text={`Rapport  ${select.toLocaleLowerCase()} ${
            statsData?.data?.rapport?.totalRapportEnAttente ?? "--"
          }`}
        />
        <Counter
          icon={
            <div className="text-black ">
              <Connecting />
            </div>
          }
          color={"bg-[#f9e0e1]"}
          label={"Raccordement realisé"}
          count={statsData?.data?.stats?.totalOk}
          text={`Rapport ${select.toLocaleLowerCase()} ${
            statsData?.data?.rapport?.totalRapportOk ?? "--"
          }`}
        />
        <Counter
          icon={
            <div className="text-black ">
              <UnLink />
            </div>
          }
          color={"bg-[#f9e0e1]"}
          label={"Raccordement realisé Non OK"}
          count={statsData?.data?.stats?.totalNonOk}
          text={`Rapport ${select.toLocaleLowerCase()} ${
            statsData?.data?.rapport?.totalRapportNonOk ?? "--"
          }`}
        />
      </div>

      {filteredTabsData.length !== 0 ? (
        <Tabs
          tabsData={filteredTabsData}
          active={active}
          setActive={setActive}
        />
      ) : null}

      <div className="bg-white rounded-md px-2 py-4 mt-3">
        <div className="mt-3 lg:flex items-center gap-2">
          {active && active.tag === "LISTE_RACCORDEMENT" ? (
            <>
              <input
                type="text"
                onChange={(e) => {
                  store.getData(
                    LIST_RACCORDEMENT,
                    { page: 0, param: e.target.value, size: 6 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=OK&inTime=`,
                  );
                }}
                placeholder="Rechercher element..."
                className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
              />
              <select
                onChange={(e) =>
                  store.getData(
                    LIST_RACCORDEMENT,
                    { page: 0, param: "", size: 6 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=OK&inTime=${e.target.value}`,
                  )
                }
                className="select pl-non my-3"
              >
                <option disabled selected>
                  Delais de traitement
                </option>
                <option value="">Tout afficher</option>
                <option value={"true"}>Intention dans le delais</option>
                <option value={"false"}>Intention hors delais</option>
              </select>
              <select
                onChange={(e) => {
                  setFilterByResult(e.target.value);
                  store.getData(
                    LIST_RACCORDEMENT,
                    { page: 0, param: "", size: 6 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=${e.target.value}&inTime=`,
                  );
                }}
                className="select"
              >
                <option disabled>Resultat</option>
                <option value="OK" selected>
                  OK
                </option>
                <option value="NON_OK">Non OK</option>
                <option value={"PARTIALY_OK"}>Partialy OK</option>
              </select>
              <button
                className="btn btn-sm bg-main text-black"
                onClick={handleDownload}
              >
                Exporter
              </button>
            </>
          ) : (
            <div className="flex items-center gap-2">
              <input
                type="text"
                onChange={(e) => {
                  raccor.getData(
                    `${TYPE_RENDEZ_VOUS}?page=0&param=${e.target.value}&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_RACCORDEMENT&statutPriseEnCharge=&resultat=&typeRdv=RACCORDEMENT&inTime=`,
                  );
                }}
                placeholder="Rechercher element..."
                className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
              />

              <select
                onChange={(e) =>
                  raccor.getData(
                    `${TYPE_RENDEZ_VOUS}?page=0&param=&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_RACCORDEMENT&statutPriseEnCharge=&resultat=&typeRdv=RACCORDEMENT&inTime=${e.target.value}`,
                  )
                }
                className="select pl-non my-3"
              >
                <option disabled selected>
                  Delais de traitement
                </option>
                <option value="">Tout afficher</option>
                <option value={"true"}>Intention dans le delais</option>
                <option value={"false"}>Intention hors delais</option>
              </select>
            </div>
          )}
        </div>
        <dialog id={`edit_brin`} className="modal bg-slate-900/70">
          <div className="modal-box w-11/12 max-w-lg h-96">
            <div className="flex items-center justify-between p-3">
              <div className="">
                <h2 className="font-extrabold flex flex-row items-center text-lg mb-8 text-[#000000a8]">
                  Modification de Brin
                </h2>
                <p className="text-red-500 text-xs">{error}</p>
              </div>
              <form method="dialog">
                <button
                  id="fermer_brin"
                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                >
                  ✕
                </button>
              </form>
            </div>

            <div className="">
              <select
                onChange={(e) => setSelectBrin(e.target.value)}
                className="select pl-non w-full"
              >
                <option selected value="">
                  Liste des brins
                </option>
                {listBrin?.data?.data?.map((item) => (
                  <option value={item?.id}>{item?.designation}</option>
                ))}
              </select>
              <button
                onClick={() => {
                  if (selectItem !== null && selectBrin !== null) {
                    add(
                      `${UPDATE_BRIN}/${selectBrin}?numeroTicket=${selectItem}`,
                      "application/json",
                      {},
                    )
                      .then(() => {
                        raccor.getData(
                          `${TYPE_RENDEZ_VOUS}?page=0&param=&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_RACCORDEMENT&statutPriseEnCharge=&resultat=&typeRdv=RACCORDEMENT&inTime=`,
                        );
                        document.getElementById("fermer_brin").click();
                        toast.success("Operation effectuté");
                      })
                      .catch(() => {});
                  } else {
                    setError("Champs obligatoire");
                  }
                }}
                className="mt-3 btn btn-sm bg-main text-xs"
              >
                Modifier
              </button>
            </div>
          </div>
        </dialog>

        {active && active.tag === "LISTE_EN_ATTENTE_RACCORDEMENT" ? (
          <>
            <div className=" grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
              {raccor?.data?.data?.length === 0 ? (
                <div className="">
                  <p className="text-sm ">Aucune donnée </p>
                </div>
              ) : raccor?.data?.data?.length !== 0 && !raccor?.loading ? (
                raccor?.data?.data?.map((item) => (
                  <div
                    className={`${
                      !item?.inTime
                        ? "border-red-300 border-2 border-dashed"
                        : "border-slate-200 border"
                    } ${
                      item?.statusSuppression === "EN_ATTENTE" && "opacity-30"
                    }  relative bg-white rounded-xl  shadow-sm`}
                  >
                    <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                      <p className="text-[12px] font-semibold">
                        N° {item?.abonnement?.eligibilite?.numeroTicket}
                      </p>
                      <div className="ml-auto flex items-center gap-2">
                        <div
                          className={` px-1 border  rounded-full py-[2px] text-xs ${
                            item?.abonnement?.statusConfirmation === "CONFIRMER"
                              ? "text-green-600"
                              : "text-gray-500"
                          }  font-semibold`}
                        >
                          {item?.abonnement.statusConfirmation?.toLowerCase()}
                        </div>
                      </div>
                    </div>
                    <div className=" px-3 py-2 ">
                      <div className="items-center gap-2 space-y-3">
                        <Periode item={item} />
                        <Pbo
                          pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                          port={item?.brin}
                        />
                        <div className="flex gap-1 my-3">
                          <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                          <div>
                            <p className="text-[13px] font-medium">
                              {item?.abonnement?.client?.nomPrenoms}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              <span>{item?.abonnement.client?.numero}</span>{" "}
                              {" | "}{" "}
                              <span>
                                {item?.abonnement.client?.secondNumero}
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                        <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <CalendarIcon />
                            {item?.dateRdv}
                          </p>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>

                        <div className=" gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p>
                          </div>
                        </div>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Equipe en charge : {item?.equipe?.designation}
                        </h1>

                        <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <HomeIcon />
                            {item?.abonnement?.batiment?.designation}
                          </p>
                          <p className="text-xs flex gap-1 font-medium">
                            <ArchiveIcon />{" "}
                            {item?.abonnement?.equipement?.designation}{" "}
                          </p>
                        </div>
                      </div>
                      <h1 className="my-2 text-[13px] font-medium flex items-center">
                        <SewingPinFilledIcon />
                        {item?.abonnement?.commune +
                          ", " +
                          item?.abonnement?.quartier}
                      </h1>
                      <div className="flex items-center gap-1">
                        <h5 className="text-xs font-medium ">Etape:</h5>
                        <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                          {item?.abonnement?.status
                            ?.toLowerCase()
                            .replace(/_/g, " ")}
                        </p>
                      </div>
                      {/* {
                                                            !item?.port ? <button>AJouter un port</button> : checkTagValidity('POURSUIVRE_RACCORDEMENT') ?
                                                                <NavLink
                                                                    className='btn btn-sm bg-main my-3 font-mtn text-xs font-regular'
                                                                    to={`${HOME}/Raccordement/poursuivre-intention/${item?.abonnement?.eligibilite?.numeroTicket}/9`}>
                                                                    Poursuivre
                                                                </NavLink>
                                                                : null
                                                        } */}
                      <button
                        onClick={() => {
                          setSelectItem(
                            item?.abonnement?.eligibilite?.numeroTicket,
                          );
                          listBrin.getData(
                            `/${item?.abonnement?.eligibilite?.pbo?.id}?page=0&size=8&status=LIBRE`,
                          );
                          document.getElementById("edit_brin").showModal();
                        }}
                        className="mx-2 btn btn-sm text-xs"
                      >
                        Modifier le brin
                      </button>
                      {checkTagValidity("POURSUIVRE_RACCORDEMENT") &&
                      item?.statusSuppression !== "EN_ATTENTE" ? (
                        <NavLink
                          className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                          to={`${HOME}/Raccordement/poursuivre-intention/${item?.abonnement?.eligibilite?.numeroTicket}/11/${item?.abonnement?.eligibilite?.pbo.id}`}
                        >
                          Poursuivre
                        </NavLink>
                      ) : null}
                    </div>
                  </div>
                ))
              ) : (
                <ContentLoading />
              )}
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => moreEnAttente(newValue)}
                onSelect={(selectedPage) => moreEnAttente(selectedPage)}
                count={raccor?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : active && active.tag === "LISTE_RACCORDEMENT" ? (
          <>
            <div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 my-4">
                {store?.data?.data?.map((item) => (
                  <div
                    className={`${
                      !item?.inTime
                        ? "border-red-300 border-2 border-dashed"
                        : "border-slate-200 border"
                    } relative bg-white rounded-xl  shadow-sm`}
                  >
                    <div className="rounded-t-xl flex items-center gap-3 bg-orange-100 px-2 py-3">
                      <p className="text-[12px] font-semibold">
                        Ticket N°{item?.abonnement?.eligibilite?.numeroTicket}
                      </p>
                      {item.resultat === "OK" ? (
                        <CheckCircledIcon className="ml-auto bg-green-600 w-4 h-4 rounded-full text-white" />
                      ) : item.resultat === "NON_OK" ? (
                        <CrossCircledIcon className="bg-red-600 w-4 h-4 rounded-full text-white" />
                      ) : null}
                    </div>
                    <div className=" px-3 py-2 ">
                      <div className="my-1 flex items-center">
                        <div className="flex items-center gap-2">
                          <Pbo
                            pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                            port={item?.brin}
                          />
                        </div>
                      </div>
                      <div className="items-center gap-2 space-y-3">
                        <div
                          className={` px-3 border w-fit rounded-full py-1 text-xs ${
                            item?.status === "EN_ATTENTE"
                              ? "text-orange-600"
                              : item?.status === "En attente"
                                ? "text-gray-500"
                                : "text-green-600"
                          }  font-semibold`}
                        >
                          {item?.status?.toLowerCase().replace(/_/g, " ")}
                        </div>

                        <h1 className="text-[14px] font-bold flex items-center">
                          <SewingPinFilledIcon />
                          {item?.abonnement?.commune +
                            ", " +
                            item?.abonnement?.quartier}
                        </h1>
                        <div className="border-dashed border w-fit px-1 py-[2px] bg-green-50 text-green-800 border-green-600 rounded">
                          <p className="text-xs flex gap-1 items-center font-bold">
                            <CalendarIcon /> Réalisé le :{" "}
                            {item.dateFin
                              ? new Date(item.dateFin).toLocaleString()
                              : "--"}
                          </p>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>

                        <div className=" gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p>
                          </div>
                        </div>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Equipe en charge : {item?.equipe?.designation}
                        </h1>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Réaliser par :{" "}
                          {item?.technicien?.nomPrenoms +
                            " | " +
                            item?.technicien?.numero}
                        </h1>
                        {item.resultat === "OK" ? (
                          <div className="dropdown flex items-center">
                            <p className="text-xs">
                              Commentaire: {item?.commentaire}{" "}
                            </p>
                          </div>
                        ) : null}

                        <div className="flex gap-1 ">
                          <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                          <div>
                            <p className="text-[13px] font-medium">
                              {item?.abonnement?.client?.nomPrenoms}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              <span>{item?.abonnement?.client?.numero}</span>{" "}
                              {" | "}{" "}
                              <span>
                                {item?.abonnement?.client?.secondNumero}
                              </span>{" "}
                            </p>
                          </div>
                        </div>

                        {item.resultat === "OK" ? null : checkTagValidity(
                            "MODIFIER_RACCORDEMENT",
                          ) ? (
                          <button
                            onClick={() => {
                              setNumeroTicket(
                                item?.abonnement?.eligibilite?.numeroTicket,
                              );
                              document.getElementById("edit").showModal();
                            }}
                            className="ml-auto text-white text-xs btn btn-sm bg-black"
                          >
                            <Pencil1Icon /> Modifier
                          </button>
                        ) : null}
                        {checkTagValidity("DETAILS_RACCORDEMENT") ? (
                          <button
                            onClick={() => {
                              document
                                .getElementById(`show${item.id}`)
                                .showModal();
                            }}
                            className="btn btn-sm bg-main text-xs"
                          >
                            Details du raccordement
                          </button>
                        ) : null}

                        <dialog
                          id={`show${item.id}`}
                          className="modal bg-slate-900/70"
                        >
                          <div className="relative modal-box">
                            <div className="flex items-center justify-between p-3">
                              <div className="flex flex-row gap-2"></div>
                              <form method="dialog">
                                <button
                                  id="fermer_create_trajet"
                                  className="absolute top-4 right-4"
                                >
                                  ✕
                                </button>
                              </form>
                            </div>
                            <div>
                              <div className="">
                                <div className="bg-white p-3 rounded-lg">
                                  <div className="">
                                    <h3 className="font-mtn lg:text-lg text-2xl text-amber-500 font-bold">
                                      Ticket N°
                                      {
                                        item?.abonnement?.eligibilite
                                          ?.numeroTicket
                                      }
                                    </h3>
                                  </div>
                                  <div className="mt-3 border-t border-dashed border-amber-300">
                                    <dl className="divide-y divide-gray-100">
                                      <div className="py-3 ">
                                        <dt className="text-sm text-gray-500">
                                          Client
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6  ">
                                          {item?.abonnement?.client?.nomPrenoms}
                                        </dd>
                                      </div>

                                      <div className="py-3">
                                        <dt className="text-sm leading-6 text-gray-500">
                                          Email
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6  ">
                                          {item?.abonnement?.client?.email}
                                        </dd>
                                      </div>
                                      <div className="py-3 ">
                                        <dt className="text-sm  leading-6 text-gray-500">
                                          Contact client
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 ">
                                          {item?.abonnement?.client?.numero}
                                        </dd>
                                      </div>
                                      <div className="py-3 ">
                                        <dt className="text-sm  leading-6 text-gray-500">
                                          Numero avantage
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 ">
                                          {item?.abonnement?.numeroMtn}
                                        </dd>
                                      </div>
                                      <div className="py-3 ">
                                        <dt className="text-sm  leading-6 text-gray-500">
                                          Ville du client
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 ">
                                          {
                                            item?.abonnement?.domicile?.quartier
                                              ?.commune?.designation
                                          }
                                        </dd>
                                      </div>
                                      <div className="py-3 ">
                                        <dt className="text-sm  leading-6 text-gray-500">
                                          Quartier
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6">
                                          {
                                            item?.abonnement?.domicile?.quartier
                                              ?.designation
                                          }
                                        </dd>
                                      </div>

                                      <div className="py-3 ">
                                        <dt className="text-sm  leading-6 text-gray-500">
                                          Status d'éligibilité
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 font-medium text-amber-600 ">
                                          {item?.abonnement?.eligibilite
                                            ?.ftthEligible === "yes"
                                            ? "Eligible"
                                            : "Pas eligible"}
                                        </dd>
                                      </div>

                                      <div className="py-3 ">
                                        <dt className="text-sm  leading-6 text-gray-500">
                                          Forfait souhaité
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-amber-500 ">
                                          {
                                            item?.abonnement?.forfait
                                              ?.designation
                                          }
                                        </dd>
                                      </div>
                                    </dl>
                                  </div>
                                </div>
                              </div>
                              <div className="">
                                <p className="p-3 font-bold text-lg font-mtn text-amber-600">
                                  Information sur le raccordement
                                </p>
                                <div className="bg-white p-3 rounded-lg">
                                  <div className="">
                                    <dl className="divide-y divide-gray-100">
                                      <div className="py-3 ">
                                        <dt className="text-sm  text-gray-500">
                                          Date de rendez-vous
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                          {item.dateRdv}
                                        </dd>
                                      </div>

                                      <div className="py-3 ">
                                        <dt className="text-sm  text-gray-500">
                                          Date debut réalisation
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                          {item?.dateDebut
                                            ? new Date(
                                                item?.dateDebut,
                                              ).toLocaleString()
                                            : "--"}
                                        </dd>
                                      </div>

                                      <div className="py-3 ">
                                        <dt className="text-sm  text-gray-500">
                                          Date fin réalisation
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                          {item?.dateFin
                                            ? new Date(
                                                item?.dateFin,
                                              ).toLocaleString()
                                            : "--"}
                                        </dd>
                                      </div>

                                      <div className="py-3 ">
                                        <dt className="text-sm  text-gray-500">
                                          Status du raccordement
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                          {item?.status?.toLocaleLowerCase() ??
                                            "--"}
                                        </dd>
                                      </div>

                                      <div className="py-3 ">
                                        <dt className="text-sm  text-gray-500">
                                          Status de réalisation
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                          {item?.resultat.replace("_", " ") ??
                                            "--"}
                                        </dd>
                                      </div>

                                      <div className="py-3 ">
                                        <dt className="text-sm  leading-6 text-gray-500">
                                          Créneau horaire
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                          {item?.crenau?.heureDebut +
                                            " à " +
                                            item?.crenau?.heureFin}
                                        </dd>
                                      </div>
                                      <div className="py-3 ">
                                        <dt className="text-sm  leading-6 text-gray-500">
                                          Réalisé par
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                          {item?.equipe?.designation ?? "--"}
                                        </dd>
                                      </div>
                                    </dl>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </dialog>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <dialog id="edit" className="modal ">
                <div className="modal-box w-10/12 max-w-2xl">
                  <div className="modal-action">
                    <h1 className="mr-auto text-2xl font-bold font-mtn">
                      Modification du raccordement
                    </h1>
                    <form method="dialog">
                      <button
                        id="fermer"
                        className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                      >
                        ✕
                      </button>
                    </form>
                  </div>
                  <UpdateRaccordement
                    numeroTicket={numeroTicket}
                    setActive={setActive}
                  />
                </div>
              </dialog>
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={store?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Raccordement;
